import toString from './to-string';
var upperCase = function (str) {
  return toString(str).toUpperCase();
};
export default upperCase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/upper-case.js
// module id = 83
// module chunks = 0